<template>
  <div class="image-container">
    <img :src="img.img" class="image">
    <div class="overlay">
      <div class="overlay-text">{{img.name}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImgGroup',
  props: {
    img: Object,
  },
}
</script>

<style scoped>
.image-container {
  position: relative;
  display: inline-block;
  width: 100%;
  overflow: hidden;
  cursor: pointer;
}

.image {
  display: block;
  width: 100%;
  height: auto;
  transition: all 0.3s ease;
}

.overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 15px 0;
  background-color: rgba(29, 28, 28, 0.5); /* 默认灰色半透明条 */
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
}

.overlay-text {
  color: white;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  width: 100%;
  transition: all 0.3s ease;
}

/* 悬停效果 */
.image-container:hover .overlay {
  top: 0;
  height: 100%;
  background-color: rgba(239, 128, 26, 0.7); /* 悬停时橙色半透明覆盖 */
  padding: 0;
}

.image-container:hover .overlay-text {
  font-size: 24px; /* 悬停时文字变大 */
}

.image-container:hover .image {
  transform: scale(1.05); /* 悬停时图片轻微放大 */
}
</style>